



















import { Vue, Component } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import ActivityLabel from "@/components/common/edit/ActivityLabel.vue";
import MusicListModal from "@/components/common/edit/MusicListModal.vue";

@Component({
  components: {
    "activity-label": ActivityLabel,
    "music-list-modal": MusicListModal
  }
})
export default class BackgroundMusic extends Vue {
  @Getter("selectedBGM") selectedBGM!: any;
  @Getter("section") section!: any;
  @Action("changeShowFooter") changeShowFooter!: Function;

  showMusicModal: boolean = false;

  handleShowMusicModal(): void {
    this.showMusicModal = true;
    this.changeShowFooter(false);
  }

  handleHideShowMusicModal(): void {
    this.showMusicModal = false;
    this.changeShowFooter(true);
  }
}
